import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../utils/userProvider";
import axios from "axios";

export default function usePromotions(year = "last12months") {
  let backend_url;

  if (year === "last12months") {
    // Calculate dates for the past year
    const today = new Date();
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(today.getFullYear() - 1);
    backend_url = `${
      process.env.REACT_APP_BACKEND_URL
    }/credit-notes?triggerDate_gte=${oneYearAgo.toISOString()}&triggerDate_lte=${today.toISOString()}`;
  } else if (year === "next18months") {
    // Calculate dates for next 18 months
    const today = new Date();
    const eighteenMonthsLater = new Date();
    eighteenMonthsLater.setMonth(today.getMonth() + 18);
    backend_url = `${
      process.env.REACT_APP_BACKEND_URL
    }/credit-notes?triggerDate_gte=${today.toISOString()}&triggerDate_lte=${eighteenMonthsLater.toISOString()}`;
  }  else if (year === "all") {
    // Get all credit notes without date filter
    backend_url = `${process.env.REACT_APP_BACKEND_URL}/credit-notes?_limit=-1`;
  }  else {
    // If year is not provided, get current year
    const targetYear = year || new Date().getFullYear();
    const startDate = `${targetYear}-01-01T00:00:00.000Z`;
    const endDate = `${targetYear}-12-31T23:59:59.999Z`;
    backend_url = `${process.env.REACT_APP_BACKEND_URL}/credit-notes?triggerDate_gte=${startDate}&triggerDate_lte=${endDate}`;
  }

  const { authState, setAuthState } = useContext(AuthContext);
  const [res, setRes] = useState({
    data: null,
    complete: false,
    loading: false,
    error: false,
  });

  const [resetCount, setResetCount] = useState(0);

  const reset = () => {
    var newResetCount = resetCount + 1;
    setResetCount(newResetCount);
  };

  useEffect(() => {
    setRes({
      data: null,
      loading: true,
      error: false,
      complete: false,
    });
    axios({
      url: backend_url,
      method: "GET",
      headers: {
        Authorization: `Bearer ${authState.jwt ? authState.jwt : ""}`,
      },
    })
      .then((res) =>
        setRes({
          data: res.data,
          loading: false,
          error: false,
          complete: true,
        })
      )
      .catch((e) =>
        setRes({
          data: null,
          loading: false,
          error: true,
          errorMessage: e.response,
          complete: true,
        })
      );
  }, [resetCount, year]);

  return [res, reset];
}
